module.exports = __webpack_public_path__ + "img/4_14.51757319.png";